import { render, staticRenderFns } from "./Formato.vue?vue&type=template&id=ee22be0c&"
import script from "./Formato.vue?vue&type=script&lang=js&"
export * from "./Formato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports